<app-table [data]="toolRequests"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [saveFilters]="true"
           [headerBackgroundColor]="headerBackgroundColor"
           [hasTitle]="hasTitle"
           [isMaterial]="false"
           title="{{'atom.tool-requests-facilities.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)">
    <app-table-column header="{{'atom.tool-requests-facilities.table.columns.createdAt' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-facilities.table.filters.byCreatedTime' | translate}}"
                      field="name">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.createdDate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-facilities.table.columns.facility' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-facilities.table.filters.byFacility' | translate}}"
                      filter="true"
                      field="facility"
                      [sortable]="false">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.facility?.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-facilities.table.columns.status' | translate}}"
                      filterPlaceholder="{{'atom.tool-requests-facilities.table.filters.byStatus' | translate}}"
                      [sortable]="false"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          displayField="name"
                          valueField="value"
                          emptyText="{{'atom.tool-requests-facilities.table.columns.status' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'atom.tool-requests-facilities.table.columns.actions' | translate}}">
        <ng-template #body
                     let-toolRequest="rowData">
            <app-button type="primary" *ngIf="shouldRenderProcess(toolRequest)" class="process-button"
                        (click)="process(toolRequest)">{{ 'generic.buttons.process' | translate }}
            </app-button>
            <app-button type="warning" *ngIf="shouldRenderResume(toolRequest)"
                        class="process-button amber"
                        (click)="resume(toolRequest)">{{ 'generic.buttons.resumeProcessing' | translate }}
            </app-button>
        </ng-template>
    </app-table-column>
</app-table>
